import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actionTypes from '../../store/actions';
import classes from './AllocationDropDown.css';

export class AllocationDropDown extends Component {

    state = {
        allocationId: ""
    };

    updateAllocationId = (event) => {
        let newState = Object.assign({}, this.state);
        newState.allocationId = event.target.value;
        this.setState(newState);
        this.props.updateAllocationId(event.target.value);
    };

    render() {

        let invalidClass = "";

        if (this.props.allocationInvalid) {
            invalidClass = "invalid";
        }

        let allocationOptions = this.props.allocationList.map((allocation)=> {
            return (
                <option value={allocation.allocationModelId}>{allocation.allocationModelName}</option>
            );
        });

        return (
            <div className={classes.AllocationDropDown}>
                <select onChange={this.updateAllocationId} value={this.props.allocationId} className={invalidClass}>
                    <option value="CHOOSE">---Please Select---</option>
                    {allocationOptions}
                </select>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        allocationInvalid: state.planInfo.allocation.invalid,
        allocationList: state.planInfo.allocationList,
        allocationId: state.planInfo.allocation.allocationId
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateAllocationId: (value) => dispatch({type: actionTypes.UPDATE_ALLOCATION_ID, allocationId: value})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AllocationDropDown);


// WEBPACK FOOTER //
// ./src/containers/AllocationDropDown/AllocationDropDown.js